module.exports = __webpack_public_path__ + "static/img/goodness7.c313118c.png";